
import React, { useState } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import { useYearContext } from "../../admin/components/YearContext";
import { LuPaperclip } from "react-icons/lu";
import Litax_2025 from "../pdf/Litax Inc. TY 2025.docx";
import Litax_2024 from "../pdf/Litax Inc. TY 2024.docx";
import Litax_2023 from "../pdf/Litax Inc. TY 2023.docx";
import Litax_2022 from "../pdf/Litax Inc. TY 2022.docx";

function Taxorganizer() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const files = [
    {
      year: 2025,
      file: Litax_2025,
      name: "Litax Inc. TY 2025.docx",
    },
    {
      year: 2024,
      file: Litax_2024,
      name: "Litax Inc. TY 2024.docx",
    },
    {
      year: 2023,
      file: Litax_2023,
      name: "Litax Inc. TY 2023.docx",
    },
    {
      year: 2022,
      file: Litax_2022,
      name: "Litax Inc. TY 2022.docx",
    },
  ];

  const selectedFile = files.find((file) => file.year == yearSelected);

  const handleDownload = () => {
    if (!selectedFile) return;
    const link = document.createElement("a");
    link.href = selectedFile.file;
    link.download = selectedFile.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <h4>Tax Organizer</h4>

          <div className="mt-3 d-flex align-items-center justify-content-between border p-2 rounded">
            <p className="mb-0">
              <LuPaperclip size={22} className="me-2" />

              {selectedFile ? (
                <span>{selectedFile.name}</span>
              ) : (
                <span>No file available for the selected year</span>
              )}
            </p>

            <button
              className="btn btn-sm btn-primary"
              onClick={handleDownload}
              title="Download File"
              disabled={!selectedFile}
            >
              Download
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Taxorganizer;